import { motion } from "framer-motion";

const ScienceTeam = () => (
  <section data-testid="science-team-section" className="relative pt-20">
    <div className="relative h-[70vh] md:h-[86vh]">
      <img
        src="/assets/science_man_room.jpg"
        alt="Nimrod Mon Brokman, Trifit's Head of Science, sitting in a quiet room, reflecting"
        data-testid="science-team-image"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink/40 via-transparent to-[#1A1016]" />
      <div className="absolute inset-x-0 top-12 z-10 px-6 md:top-16 md:px-12">
        <p
          data-testid="science-eyebrow"
          className="font-mono text-[11px] tracking-[0.3em] text-white/80"
        >
          01 · THE SCIENCE
        </p>
      </div>
    </div>
    <div className="relative z-10 -mt-24">
      <div className="h-24 w-full rounded-t-[100%] bg-[#1A1016]" />
      <div className="bg-[#1A1016] px-6 pb-24 pt-6 text-center md:px-12 md:pb-32">
        <p className="font-mono text-[10px] tracking-[0.3em] text-ash">
          02 · THE PEOPLE
        </p>
        <motion.h2
          data-testid="science-team-headline"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mx-auto mt-8 max-w-3xl font-display text-4xl font-light leading-tight text-white md:text-5xl"
        >
          Meet the Science Team
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.25 }}
          className="mx-auto mt-8 max-w-xl text-sm leading-relaxed text-fog md:text-base"
        >
          Trifit runs on behavioural psychology. Our scientists translate
          decades of research on habit formation, motivation and adherence into
          every plan, nudge and conversation, so the system works with your
          psychology, never against it.
        </motion.p>
      </div>
    </div>
  </section>
);

export default ScienceTeam;
